import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { U2000ToastProvider } from "./app/u2000Core/context/toast/U2000ToastContext";
import { U2000AuthProvider } from "./app/u2000Core/context/auth/U2000AuthContext";
import { U2000BusyIndicatorProvider } from "./app/u2000Core/context/busiIndicator/U2000BusyIndicatorContext";
import { U2000WebSocketProvider } from "./app/u2000Core/context/websocket/U2000WebSocketContext";
import { U2000NotificationProvider } from "./app/u2000Core/context/notification/U2000NotificationContext";
import U2000UnAuthorized from "./app/u2000Core/components/controls/U2000UnAuthorized";
import U2000NotFound from "./app/u2000Core/components/controls/U2000NotFound";
import U2000DefaultRedirect from "./app/u2000Core/components/controls/U2000DefaultRedirect";
import U2000WorkSpace from "./app/u2000Core/components/layout/workspace/U2000WorkSpace";
import U2000RequireAuth from "./app/u2000Core/components/controls/U2000RequireAuth";
import U2000PersistLogin from "./app/u2000Core/components/controls/U2000PersistLogin";
import U2001Routes from "./app/u2001Login/U2001Routes";
import U2201Routes from "./app/u2201JobSchedule/U2201Routes";
import U2101Routes from "./app/u2101LogicalUnit/U2101Routes";
import U2102Routes from "./app/u2102Role/U2102Routes";
import U2103Routes from "./app/u2103User/U2103Routes";
import U2104Routes from "./app/u2104Organization/U2104Routes";
import U3148Routes from "./app/u3148MyOrganization/U3148Routes";
import U2106Routes from "./app/u2106MyAccount/U2106Routes";
import U2107Routes from "./app/u2107LogicalUnitCategory/U2107Routes";
import U3101Routes from "./app/u3101Employee/U3101Routes";
import U3104Routes from "./app/u3104AccountingPeriod/U3104Routes";
import U3105Routes from "./app/u3105PayrollPeriod/U3105Routes";
import U3106Routes from "./app/u3106ExpenseType/U3106Routes";
import U3107Routes from "./app/u3107Equipment/U3107Routes";
import U3110Routes from "./app/u3110TaxRate/U3110Routes";
import U3120Routes from "./app/u3120Customer/U3120Routes";
import U3121Routes from "./app/u3121Project/U3121Routes";
import U3146Routes from "./app/u3146ProjectClose/U3146Routes";
import U3125Routes from "./app/u3125Facture/U3125Routes";
import U3129Routes from "./app/u3129Timesheet/U3129Routes";
import U3147Routes from "./app/u3147TimeTracking/U3147Routes";
import U3130Routes from "./app/u3130TimesheetApproval/U3130Routes";
import U3134Routes from "./app/u3134WorkInProgress/U3134Routes";
import U3141Routes from "./app/u3141LandRegister/U3141Routes";
import U3142Routes from "./app/u3142Lot/U3142Routes";
import U3143Routes from "./app/u3143DistrictCadastre/U3143Routes";
import U3139Routes from "./app/u3139Minutes/U3139Routes";
import U3144Routes from "./app/u3144LotDetailOperationType/U3144Routes";
import U3149Routes from "./app/u3149WorkNature/U3149Routes";
import U3150Routes from "./app/u3150Task/U3150Routes";
import U3157Routes from "./app/u3157WorkNatureImportModel/U3157Routes";
import U3151Routes from "./app/u3151CustomerType/U3151Routes";
import U3152Routes from "./app/u3152ContactType/U3152Routes";
import U3153Routes from "./app/u3153InvoiceType/U3153Routes";
import U3154Routes from "./app/u3154PaymentType/U3154Routes";
import U3155Routes from "./app/u3155MinutesWorkNature/U3155Routes";
import U2202Routes from "./app/u2202ConnectedUser/U2202Routes";
import U3203Routes from "./app/u3203AiMission/U3203Routes";
import U3202Routes from "./app/u3202AiProvider/U3202Routes";
import U3204Routes from "./app/u3204AiChat/U3204Routes";
import U3206Routes from "./app/u3206AiUserGroup/U3206Routes";
import U3207Routes from "./app/u3207AiUsageDashboard/U3207Routes";
import U3208Routes from "./app/u3208AiRagDocument/U3208Routes";
import U3301Routes from "./app/u3301Calendar/U3301Routes";
import U3302Routes from "./app/u3302CalendarCategory/U3302Routes";
import U3303Routes from "./app/u3303Holiday/U3303Routes";
import U3400Routes from "./app/u3400Dashboard/U3400Routes";
import U3401Routes from "./app/u3401KpiProjects/U3401Routes";
import U3402Routes from "./app/u3402KpiTec/U3402Routes";
import U3403Routes from "./app/u3403KpiInvoices/U3403Routes";
import U3500Routes from "./app/u3500GedDocumentSearch/U3500Routes";

export const u2000Routes = createBrowserRouter([
  {
    element: <U2000PersistLogin />,
    children: [
      {
        path: "/",
        element: <U2000RequireAuth />,
        children: [
          {
            path: "/",
            element: <U2000WorkSpace />,
            children: [
              { index: true, element: <U2000DefaultRedirect /> },
              ...U2201Routes,
              ...U2101Routes,
              ...U2102Routes,
              ...U2103Routes,
              ...U2104Routes,
              ...U3148Routes,
              ...U2106Routes,
              ...U2107Routes,
              ...U2202Routes,
              ...U3101Routes,
              ...U3104Routes,
              ...U3105Routes,
              ...U3106Routes,
              ...U3107Routes,
              ...U3110Routes,
              ...U3120Routes,
              ...U3121Routes,
              ...U3146Routes,
              ...U3125Routes,
              ...U3129Routes,
              ...U3147Routes,
              ...U3130Routes,
              ...U3134Routes,
              ...U3142Routes,
              ...U3143Routes,
              ...U3139Routes,
              ...U3144Routes,
              ...U3149Routes,
              ...U3157Routes,
              ...U3150Routes,
              ...U3151Routes,
              ...U3152Routes,
              ...U3153Routes,
              ...U3154Routes,
              ...U3155Routes,
              ...U3141Routes,
              ...U3203Routes,
              ...U3202Routes,
              ...U3206Routes,
              ...U3207Routes,
              ...U3208Routes,
              ...U3204Routes,
              ...U3301Routes,
              ...U3302Routes,
              ...U3303Routes,
              ...U3400Routes,
              ...U3401Routes,
              ...U3402Routes,
              ...U3403Routes,
              ...U3500Routes,
              { path: "/unauthorized", element: <U2000UnAuthorized /> },
            ],
          },
        ],
      },
    ],
  },
  // Public Routes
  ...U2001Routes,
  // Catch-all route for 404
  { path: "*", element: <U2000NotFound /> },
] as any);

const App = () => {
  return (
    <U2000ToastProvider>
      <U2000AuthProvider>
        <U2000BusyIndicatorProvider>
          <U2000WebSocketProvider>
            <U2000NotificationProvider>
              <RouterProvider router={u2000Routes} />
            </U2000NotificationProvider>
          </U2000WebSocketProvider>
        </U2000BusyIndicatorProvider>
      </U2000AuthProvider>
    </U2000ToastProvider>
  );
};

export default App;
